import { render, staticRenderFns } from "./insertCashBoxesOpeningBalance.vue?vue&type=template&id=820a382c&scoped=true"
import script from "./insertCashBoxesOpeningBalance.vue?vue&type=script&lang=js"
export * from "./insertCashBoxesOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./insertCashBoxesOpeningBalance.vue?vue&type=style&index=0&id=820a382c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820a382c",
  null
  
)

export default component.exports